import { gql } from 'graphql-tag'

export const UPDATE_ACCOUNT_PREFERRED_CURRENCY_MUTATION = gql`
  mutation UpdateAccountPreferredCurrency($preferredCurrency: Currency!) {
    updatePreferredCurrency(preferredCurrency: $preferredCurrency) {
      preferredCurrency
    }
  }
`
